import { Link, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { ProductForm } from "@/components/products/product-form";

export function NewProductPage() {
  const navigate = useNavigate();

  return (
    <div className="p-4 flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <Link to="/products" className="text-muted-foreground hover:text-foreground">
          <ArrowLeft className="h-4 w-4" />
        </Link>
        <h2 className="text-sm font-medium">Novi proizvod</h2>
      </div>
      <ProductForm onSuccess={() => navigate({ to: "/products" })} />
    </div>
  );
}
